import { AdyenPaymentState } from "../interfaces/adyen.interface";

export const isPaymentFinished = (
  transactionStatus: AdyenPaymentState,
): boolean => {
  return transactionStatus === AdyenPaymentState.COMPLETED;
};

export const isPaymentFailed = (
  transactionStatus: AdyenPaymentState,
): boolean => {
  return transactionStatus === AdyenPaymentState.REJECTED;
};
